// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux

import { applicationTypes } from 'constants/scripts';

// constants
import {
  selectIdPrefix
} from 'constants/values';

// action types
export const typePrefix = 'vra/current/uiwidgets/product-inputs/';
export const actions = {
  'RESET_PRODUCT_INPUTS': `${typePrefix}RESET_PRODUCT_INPUTS`,
  'SET_PRODUCT_INPUT': `${typePrefix}SET_PRODUCT_INPUT`
};

const initialProductInputs = {
  // just set this outright -- the assumption is up to two hybrids
  [applicationTypes.FERTILIZER]: {
    [`${selectIdPrefix}1`]: { products: [], active: true }
  },
  [applicationTypes.SEED]: {
    [`${selectIdPrefix}1`]: { products: [], active: true },
    [`${selectIdPrefix}2`]: {}
  }
};

// Reducer
export default function reducer(
  state = {...initialProductInputs},
  action = {}
) {

  switch (action.type) {
    case actions.RESET_PRODUCT_INPUTS:
      return {...initialProductInputs};

    case actions.SET_PRODUCT_INPUT:
      return {
        ...state,
        [action.payload.applicationType]: {
          ...state[action.payload.applicationType],
          [action.payload.selectId]: {
            currentProductId: action.payload.currentProductId,
            products: action.payload.products,
            active: action.payload.active
          }
        }
      };

    default:
      return state;
  }
}

// action creators

export const resetProductInputs = () => {
  return {
    type: actions.RESET_PRODUCT_INPUTS
  };
};

export const setProductInput = ({ active, applicationType, currentProductId, products, selectId }) => {
  return {
    type: actions.SET_PRODUCT_INPUT,
    payload: { active, applicationType, currentProductId, products, selectId }
  };
};

export const unitTestPrivate = {
  initialProductInputs
};
